import React, { useState, useEffect } from "react";
import SubscriberList from "./SubscriberList";
import Transactions from "./Transactions";
import { useParams } from "react-router";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Paper,
  Card,
  CardContent,
  Grid,
  Avatar,
} from "@mui/material";
import { BusinessCenter } from "@mui/icons-material";
import axios from "axios";
import CompanyProfileCard from "./CompanyProfileCard";

const ViewCompany = () => {
  const params = useParams();
  const id = params.id;
  const [currentTab, setCurrentTab] = useState(0);
  const [companyData, setCompanyData] = useState(null);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const getCompany = async () => {
    try {
      const response = await axios.get("/company/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
        },
      });

      const companyData = response.data.company;
      setCompanyData(companyData);
    } catch (err) {
      console.error("Error fetching company data:", err);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Grid container spacing={3}>
        
        <CompanyProfileCard companyData={companyData} />
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3, mb: 3 }}>
            <Tabs value={currentTab} onChange={handleTabChange} centered>
              <Tab label="Subscriber List" />
              <Tab label="Transactions" />
            </Tabs>
            <TabPanel value={currentTab} index={0}>
              <SubscriberList name={companyData?.companyName} />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
              <Transactions type="company" />
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default ViewCompany;